const ArtistContainer = require('./ArtistContainer.jsx');
const ArtistItemContainer = require('./ItemContainer.jsx');
const ArtistMeta = require('./ArtistMeta.jsx');
const ItemMeta = require('./ItemMeta.jsx');
const Name = require('../utility/Name.jsx');

// LEGACY
const ArtistName = require('./Name.jsx');
const Bio = require('./Bio.jsx');
const CV = require('./CV.jsx');
const Image = require('./Image.jsx');
const Item = require('../common/Item.jsx');

const Blocks = {
    get: (group, data) => [
        {
            id: Name.Block.Artist.Container,
            component: ArtistContainer.PageV2,
            config: {
                Block: ArtistContainer.TypeConfigV2.panel.block(),
                Style: ArtistContainer.TypeConfigV2.panel.style(),
                Visibility: ArtistContainer.TypeConfigV2.panel.visibility(),
                defaults: [
                    { configName: 'Block', propertyName: 'design', propertyValue: ArtistContainer.TypeConfigV2.defaultDesign(data) }
                ]
            },
            display: 'Artist Container',
            group,
            image: 'artists.png',
            type: 'container'
        }
    ],
    content: {
        [Name.Block.Artist.Container]: ArtistContainer.Blocks,
        [Name.Block.Inventory.Container]: ArtistItemContainer.Blocks
    },
    tokens: (id, data) => {
        switch (id) {
            case Name.Block.Artist.Meta:
                return ArtistMeta.Tokens();
            case Name.Block.Inventory.Meta:
                return ItemMeta.Tokens(data);
        }
    },

    legacy: [
        { display: 'Artist Data Blocks', type: 'header' },
        {
            id: 'itemContainer',
            component: ArtistContainer.Page,
            config: {
                Block: ArtistContainer.TypeConfig.panel.block(),
                Columns: ArtistContainer.TypeConfig.panel.columns(),
                Style: ArtistContainer.TypeConfig.panel.style()
            },
            display: 'Artist Container (required)',
            image: '',
            type: 'container'
        },
        {
            id: 'image',
            component: Image.Component,
            config: {
                Block: Image.TypeConfig.panel.block(),
                Style: Image.TypeConfig.panel.style()
            },
            display: 'Image',
            image: ''
        },
        {
            id: 'name',
            component: ArtistName.Component,
            config: {
                Block: ArtistName.TypeConfig.panel.block(),
                Includes: ArtistName.TypeConfig.panel.includes(),
                Style: ArtistName.TypeConfig.panel.style()
            },
            display: 'Name',
            image: ''
        },
        {
            id: 'bio',
            component: Bio.Component,
            config: {
                Block: Bio.TypeConfig.panel.block(),
                Style: Bio.TypeConfig.panel.style()
            },
            display: 'Biography',
            image: ''
        },
        {
            id: 'cv',
            component: CV.Component,
            config: {
                Block: CV.TypeConfig.panel.block(),
                Style: CV.TypeConfig.panel.style()
            },
            display: 'Curriculum Vitae',
            image: ''
        },
        { display: 'Inventory Data Blocks', type: 'header' },
        {
            id: 'inventoryContainer',
            component: ArtistItemContainer.Component,
            config: {
                Block: ArtistItemContainer.TypeConfig.panel.block(),
                Columns: ArtistItemContainer.TypeConfig.panel.columns(),
                Visibility: ArtistItemContainer.TypeConfig.panel.visibility(),
                Style: ArtistItemContainer.TypeConfig.panel.style()
            },
            display: 'Inventory Container',
            image: '',
            type: 'layout'
        },
        {
            id: 'itemImage',
            component: Item.Image.Component,
            config: {
                Block: Item.Image.TypeConfig.panel.block(),
                Style: Item.Image.TypeConfig.panel.style()
            },
            display: 'Image',
            image: ''
        },
        {
            id: 'itemTitle',
            component: Item.Title.Component,
            config: {
                Block: Item.Title.TypeConfig.panel.block(),
                Style: Item.Title.TypeConfig.panel.style()
            },
            display: 'Title',
            image: ''
        },
        {
            id: 'itemDimensions',
            component: Item.Dimensions.Component,
            config: {
                Block: Item.Dimensions.TypeConfig.panel.block(),
                Style: Item.Dimensions.TypeConfig.panel.style()
            },
            display: 'Dimensions',
            image: ''
        },
        {
            id: 'itemPrice',
            component: Item.Price.Component,
            config: {
                Block: Item.Price.TypeConfig.panel.block(),
                Style: Item.Price.TypeConfig.panel.style(),
                Format: Item.Price.TypeConfig.panel.format()
            },
            display: 'Price',
            image: ''
        }
    ]
};

module.exports = {
    Blocks
};